<div
  class="skymiles-landing-page-menu__navbar"
  id="menu-navbar"
  (click)="current.toggle = !current.toggle"
>
  <div class="skymiles-landing-page-menu__navbar__hamburger">
    <img
      class="skymiles-landing-page-menu__navbar__hamburger--icon"
      alt="SVG"
    />
  </div>
  <h5 class="skymiles-landing-page-menu__navbar__label">
    {{ current.label }}
  </h5>
  <div class="skymiles-landing-page-menu__navbar__icon">
    <a
      [class]="
        current.toggle
          ? 'skymiles-landing-page-menu__navbar__icon--collapse'
          : 'skymiles-landing-page-menu__navbar__icon--expand'
      "
      href="javascript:void(0);"
      role="button"
      [attr.aria-label]="current.label"
      [attr.aria-expanded]="current.toggle"
    >
      <span class="sr-only"></span>
    </a>
  </div>
</div>
